module.exports = __webpack_public_path__ + "img/LUB00078.c1f025f1.png";